export const VideoMakerAscendSlug = 'video-maker';
